@import "../../global/theme/breakpoints";

:host {
  //sizes
  --cxsShell_Height: #{rem(4)}; //64px
  --cxsShell_MaxWidth: 1420px;
  --cxsShell_Active_UnderlineHeight: #{rem(.26)};
  --cxsShell_Active_UnderlineRadius: 0;
  --cxsShell_NavigationIconSize: #{rem(1.25)};
  --cxsShell_MenuSpaceBetween: var(--cxs-spacer-l); //spacing between menu items
  --cxsShell_ActionsSpaceBetween: var(--cxs-spacer-m); //spacing between menu items
  --cxsShell_GroupTitleSpacing: var(--cxs-spacer-xl); //spacing between menu items and group title
  --cxsShell_MenuJustifyContent: flex-end; //justify content property for menu items
  --cxsShell_MobileMenuIconSize: #{rem(1)};
  --cxsShell_AvatarSize: #{rem(4)}; //84px
  //typography
  --cxsShell_GroupTitleFont: var(--cxs-font-weight-bold) var(--cxs-font-size-base)/normal var(--cxs-font-family-bold);
  --cxsShell_NavigationFont: var(--cxs-font-weight-regular) var(--cxs-font-size-base-1)/1.2 var(--cxs-font-family-regular);
  --cxsShell_MenuFont: var(--cxs-font-weight-regular) var(--cxs-font-size-base-1)/normal var(--cxs-font-family-book);
  --cxsShell_MenuHeadingFont: var(--cxs-font-weight-medium) var(--cxs-font-size-base-1)/normal var(--cxs-font-family-medium);
  --cxsShell_MobileMenuHeadingFont: var(--cxs-font-weight-medium) var(--cxs-font-size-base)/normal var(--cxs-font-family-medium);
  --cxsShell_MenuTitleFont: var(--cxs-font-weight-regular) var(--cxs-font-size-base-3)/normal var(--cxs-font-family-bold);
  --cxsShell_MobileMenuFont:  var(--cxs-font-weight-book) var(--cxs-font-size-base-1) var(--cxs-font-family-book);
  --cxsShell_SearchFont: var(--cxs-font-weight-regular) var(--cxs-font-size-base)/normal var(--cxs-font-family-regular);
  --cxsShell_ProfileNameFont: var(--cxs-font-weight-bold) var(--cxs-font-size-base-1)/1 var(--cxs-font-family-bold);
  --cxsShell_ProfileEmailFont: var(--cxs-font-weight-regular)  calc(var(--cxs-font-size-base) * .75)/1 var(--cxs-font-family-regular);
  --cxsShell_ProfileLinksFont: var(--cxs-font-weight-regular)  var(--cxs-font-size-base-1)/normal var(--cxs-font-family-regular);
  --cxsShell_ProfileMessageFont: var(--cxs-font-weight-book) var(--cxs-font-size-base-1)/2 var(--cxs-font-family-book);
  --cxsBadge_Font: var(--cxs-font-weight-regular) var(--cxs-font-size-base-1)/1.2 var(--cxs-font-family-regular);
  --cxsShell_MobileProfileNameFont: var(--cxsShell_MobileMenuHeadingFont);
  --cxsShell_MobileProfileEmailFont: var(--cxsShell_MobileMenuFont);
  //button
  --cxsButton_BorderWidth: 1px;
  --cxsButton_Emphasized_Background: #{$blue};
  --cxsButton_Emphasized_TextColor: #{$white};
  --cxsButton_Emphasized_BorderColor: #{$blue};
  --cxsButton_Emphasized_Hover_Background: #{$blue--dark1};
  --cxsButton_Emphasized_Hover_TextColor: #{$white};
  --cxsButton_Emphasized_Hover_BorderColor: #{$blue--dark1};
  --cxsButton_Emphasized_Active_Background: #{$blue--dark};
  --cxsButton_Emphasized_Active_TextColor: #{$white};
  --cxsButton_Emphasized_Active_BorderColor: #{$blue--dark};
  --cxsButton_BorderCornerRadius: 0;
  --cxsButton_Large_Padding: var(--cxs-spacer-s) var(--cxs-spacer-m);
  --cxsButton_Large_Font: var(--cxsShell_NavigationFont);
  --cxsButton_Large_LineHeight: 1.2;
  --cxsButton_Small_Padding: #{px(6)} #{px(8)};
  --cxsButton_Small_Font: var(--cxsNavigationMediumMFont);
  --cxsButton_Small_LineHeight: #{px(16)};
  //link
  --cxsLinkColor: #{$blue};
  --cxsLink_Hover_Color: #{$blue--dark1};
  --cxsLink_Active_Color: #{$blue--dark1};
  // masthead
  --cxsShell_Background:  #{$black};
  --cxsShell_TextColor: #{$grey-4};
  --cxsShell_Active_TextColor: #{$white};
  --cxsShell_BorderColor: #{$grey-2};
  --cxsShell_MobileBorderColor: var(--cxsShell_BorderColor);
  // masthead custom
  --cxsShell_GroupTitleTextColor: #{$white};
  // masthead custom created
  --cxsShell_Hover_TextColor: #{$white};
  --cxsShell_Active_BorderColor: #{$gold};
  // Menus
  --cxsShell_MenuBoxShadow: 0 0 50px 0 rgba(0 0 0 / 20%);
  --cxsShell_MenuBackground: #{$white};
  --cxsShell_MenuTextColor: #{$grey-1};
  --cxsShell_MenuIconColor: #{$grey-2};
  --cxsShell_MobileMenuTextColor: #{$grey-0};
  --cxsShell_MobileMenuHeadingColor: #{$black};
  --cxsShell_MobileMenuIconColor: #{$grey-3};
  --cxsShell_MenuBorderColor: #{$grey-4};
  --cxsShell_MenuBackgroundGradient:  radial-gradient(50% 50% at 18% 61%, #d1dae34d 0%, #e2e1e54d 41%, #e3e1e500 82%, #e3e1e500 83%),
  radial-gradient(80% 80% at 55% 72%, #d1dae34d 0%, #e2e1e54d 41%, #e3e1e500 82%, #e3e1e500 83%),
  radial-gradient(40% 40% at 86% 21%, #d1dae34d 0%, #e2e1e54d 30%, #e3e1e500 60%),
  linear-gradient(0deg, #e1e6e9 0%, #f1f4f9 49%, #ecf0f6 60%, #fafbfd 88%, #fbfcfd 100%);
  --cxsShell_MenuHighlightBackground: #fff;
  --cxsShell_MenuHighlightTextColor: #{$grey-1};
  // Search
  --cxsShell_SearchBackground: #{$grey-1};
  --cxsShell_SearchTextColor: #{$white};
  --cxsShell_SearchIconColor: #{$grey-3};
  --cxsShell_SearchBorder: 0;
  --cxsShell_Active_SearchBorder: 2px solid #{$blue};
  --cxsShell_Hover_SearchBorder: 0;
  --cxsShell_Hover_SearchBackground: var(--cxsShell_SearchBackground);
  --cxsShell_Active_SearchBackground: #{$white};
  --cxsShell_Active_SearchIconColor: #{$black};
  --cxsShell_Active_SearchTextColor: #{$grey-0};
  --cxsShell_Active_SearchHighlightIconColor: var(--cxsShell_Active_SearchIconColor);
  --cxsShell_Active_SearchHighlightIconBackground: var(--cxsShell_Active_SearchBackground);
  --cxsShell_SearchPlaceholderColor: #{$grey-4};
  // Menu search
  --cxsShell_MenuSearchBackground: #{$white};
  --cxsShell_MenuSearchTextColor:#{$grey-1};
  --cxsShell_MenuSearchIconColor: #{$black};
  --cxsShell_MenuSearchBorder: 1px solid #{$grey-4};
  --cxsShell_MenuSearchPlaceholderColor: #{$grey-2};
  // Badge
  --cxsShell_BadgeSize: #{rem(1)};
  --cxsBadge_BlueBackground: #{$blue};
  --cxsBadge_BlueTextColor: #{$white};
  --cxsBadge_RedBackground: #{$red};
  --cxsBadge_RedTextColor:  #{$white};
  // Message strip
  --cxsMessage_InformationBorderColor: #{$blue--dark2};
  --cxsMessage_Hover_Information_BorderColor: #{$blue--light};
  --cxsMessage_Active_Information_BorderColor: #{$blue--light};
  --cxsMessage_Active_Information_Color: #{$blue--light};
  --cxsInformationBackground: #{$blue--light};
  --cxsInformationElementColor: #{$blue--dark2};
  --cxsInformationTextColor: #{$blue--dark2};
  --cxsMessage_WarningBorderColor: #{$gold--dark1};
  --cxsMessage_Hover_Warning_BorderColor: #{$gold--light};
  --cxsMessage_Active_Warning_BorderColor: #{$gold--light};
  --cxsMessage_Active_Warning_Color: #{$gold--light};
  --cxsWarningBackground: #{$gold--light};
  --cxsCriticalElementColor: #{$gold--dark1};
  --cxsCriticalTextColor: #{$gold--dark1};
  --cxsMessage_ErrorBorderColor: #{$red--dark1};
  --cxsMessage_Hover_Error_BorderColor: #{$red--light};
  --cxsMessage_Active_Error_BorderColor: #{$red--light};
  --cxsMessage_Active_Error_Color: #{$red--light};
  --cxsErrorBackground: #{$red--light};
  --cxsNegativeElementColor: #{$red--dark1};
  --cxsNegativeTextColor: #{$red--dark1};
  --cxsMessage_SuccessBorderColor: #{$green--dark1};
  --cxsMessage_Hover_Success_BorderColor: #{$green--light1};
  --cxsMessage_Active_Success_BorderColor: #{$green--light1};
  --cxsMessage_Active_Success_Color: #{$green--light1};
  --cxsSuccessBackground: #{$green--light1};
  --cxsPositiveElementColor: #{$green--dark1};
  --cxsPositiveTextColor: #{$green--dark1};
  --cxsActionBackground: #{$white};
  --cxsMessage_ActionBorderColor: #{$blue};
  --cxsMessage_Hover_Action_BorderColor: #{$white};
  --cxsMessage_Active_Action_BorderColor: #{$white};
  --cxsMessage_Active_Action_Color: #{$white};
  --cxsActionElementColor: #{$blue};
  --cxsActionTextColor: #{$grey-1};
  --cxsContent_FocusColor: #{$blue};
  --cxsContent_ContrastFocusColor: #{$blue};
  --cxsContent_IconColor: #{$grey-1};

  //Other
  --cxs-header-wrapper-inline-maring: #{rem(1.5)}; //24

  @include breakpoint(tablet) {
    --cxs-header-wrapper-inline-maring: #{rem(4.938)}; //79.008
  }

  @include breakpoint(laptop) {
    --cxs-header-wrapper-inline-maring: #{var(--cxs-spacer-l)}; //32
  }
}

@include generate-font-family-vars();
@import "ds-contextual-navigation";

